import { render, staticRenderFns } from "./AiHelpMeWrite.vue?vue&type=template&id=3a3bb09e&scoped=true"
import script from "./AiHelpMeWrite.vue?vue&type=script&lang=js"
export * from "./AiHelpMeWrite.vue?vue&type=script&lang=js"
import style0 from "./AiHelpMeWrite.vue?vue&type=style&index=0&id=3a3bb09e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3bb09e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a3bb09e')) {
      api.createRecord('3a3bb09e', component.options)
    } else {
      api.reload('3a3bb09e', component.options)
    }
    module.hot.accept("./AiHelpMeWrite.vue?vue&type=template&id=3a3bb09e&scoped=true", function () {
      api.rerender('3a3bb09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/Components/AiBuddy/AiHelpMeWrite.vue"
export default component.exports